<script lang="ts">
	import PageGrid from '../components/pageGrid.svelte';
	import Arrow90deg from '$lib/icons/arrow90deg.svelte';
	import SbRichtext from '../components/sbRichtext.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			label: string | ISbRichtext;
			subtext: string | ISbRichtext;
			assets: ISbStoryData[];
		}>['content'];
		index?: number;
		isLastStep?: boolean;
	}

	let { content, index = 0, isLastStep = false }: Props = $props();

	let isEvenStep = $derived(index % 2 === 0);
</script>

<section use:editable={content} class="text-brown-1">
	<PageGrid gridClass="grid-flow-row-dense lg:mx-[36px]">
		<div
			class="col-span-full {isEvenStep ? 'col-end-6 lg:col-start-1' : 'col-end-13 lg:col-start-8'}"
		>
			<div
				class="mb-1 text-[40px]/[135%] font-semibold lining-nums tabular-nums tracking-[-.8px] text-orange-3 lg:mb-3 lg:text-[72px]/[100%] lg:tracking-[-1.44px]"
			>
				{index + 1}
			</div>
			<h1 class="text-[24px]/[110%] font-semibold lg:text-[48px]">
				<SbRichtext text={content.label} />
			</h1>
			{#if content.subtext}
				<div
					class="mt-2 font-serif text-[16px]/[130%] tracking-[-.32px] lg:text-[20px] lg:tracking-[-.4px]"
				>
					<SbRichtext text={content.subtext} />
				</div>
			{/if}
			<div class="mt-4 lg:mt-6">
				<Blok content={content.assets[0]} />
			</div>
		</div>
		<div
			class="aspect-square self-end max-lg:hidden {isEvenStep
				? 'col-start-7 col-end-10'
				: 'col-start-4 col-end-7'}"
			class:scale-x-[-1]={!isEvenStep}
		>
			{#if !isLastStep}
				<Arrow90deg class="h-full w-full object-cover" />
			{/if}
		</div>
	</PageGrid>
</section>
